import { useEffect } from 'react';

export type PageIdentifier = 'home' | 'pre-qualify' | 'booking' | 'call-booked';

interface PageVisit {
  page: PageIdentifier;
  timestamp: number;
}

const STORAGE_KEY = 'fallback_page_visits';

export function usePageTracking(page: PageIdentifier) {
  useEffect(() => {
    // Record the page visit
    const visit: PageVisit = {
      page,
      timestamp: Date.now(),
    };

    // Get existing visits
    const existingVisits = getPageVisits();
    
    // Add new visit
    existingVisits.push(visit);
    
    // Save back to localStorage
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(existingVisits));
    } catch (error) {
      console.error('Failed to save page visit:', error);
    }
  }, [page]);
}

// Helper function to retrieve all page visits
export function getPageVisits(): PageVisit[] {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    if (!data) return [];
    return JSON.parse(data) as PageVisit[];
  } catch (error) {
    console.error('Failed to retrieve page visits:', error);
    return [];
  }
}

// Helper function to clear all page visits (for testing/admin purposes)
export function clearPageVisits(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear page visits:', error);
  }
}